import { useQuery } from "@tanstack/react-query";
import { restApiRequest, EMPLOYEE_MANAGEMENT_SERVICE } from "src/utils/Api";
import { mockData } from "src/utils/hooks/company/useEmployeeGroups";
import sortByField from "src/utils/jsHelpers/sortByField";

const useCompanyEmployeeGroupsOptions = (companyId: string, enabled: boolean) =>
  useQuery({
    enabled,
    queryKey: [
      "employee-management-groups",
      { companyId, itemsPerPage: 10000 },
    ],
    queryFn: () =>
      restApiRequest(
        EMPLOYEE_MANAGEMENT_SERVICE,
        `/employee-groups?itemsPerPage=10000&companyId=${companyId}`,
        "GET",
        {},
        mockData
      ),
    initialData: [],
    select: (
      data: {
        id: string;
        name: string;
      }[]
    ) =>
      sortByField(
        data?.map(({ name, id }) => ({
          value: id,
          label: name,
        })) || [],
        "label"
      ),
  });

export default useCompanyEmployeeGroupsOptions;
